module.exports = __webpack_public_path__ + "static/images/deleteTemplateIcon.85c9d4dd.svg";